import React, { useEffect, useState } from 'react';
import { Grid, CssBaseline, Typography } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { useEvaluationsStyles } from './style';
import { OfficialProfileNavbar } from '../../components/officialProfileNavbar/officialProfileNavbar';
import { OfficialAvatarAndName } from '../../components/officialAvatarAndName/officialAvatarAndName';
import { getPersonalDetailsByIdReq } from '../../api/person/personalDetailsApi';
import { PersonModel } from '../../models/personModel';
import { EvalueeTable } from '../../components/evaluation/evalueeTable';

export function EvaluationsByOthers() {
  const style = useEvaluationsStyles();
  const { t } = useTranslation();
  const { personId } = useParams();
  const [official, setOfficial] = useState<PersonModel>();

  useEffect(() => {
    async function getOfficialProfile() {
      if (!personId?.trim()) return;
      const response = await getPersonalDetailsByIdReq(personId.trim());
      if (response) {
        setOfficial(response.data);
      }
    }
    getOfficialProfile();
  }, [setOfficial, personId]);

  return (
    <Grid container>
      <CssBaseline />
      <OfficialProfileNavbar selectedIndex={3} personId={personId} />
      <OfficialAvatarAndName official={official} />
      <Grid container item>
        <Grid item container>
          <Grid item xs={12} className={style.titleBox}>
            <Typography variant='h5' className={style.titleText}>
              {t('evaluations_by_others')}
            </Typography>
          </Grid>
          <Grid item xs={12}>
            <EvalueeTable forPerson={personId} showToolbar={false} />
          </Grid>
        </Grid>
      </Grid>
    </Grid>
  );
}
